module.exports = __webpack_public_path__ + "img/user.37eb464f.png";